export default __webpack_public_path__ + "static/media/magnifier.8bde14c0.svg";